// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"1f5d8540","79":"c3e9843e","453":"563b458b","508":"d3324468"}[chunkId] + ".chunk.js";
};